module.exports = __webpack_public_path__ + "img/analytics.0d223daf.svg";